import Header from './components/Header';
import Hero from './components/Hero';
import SectionsOne from './components/SectionsOne';
import SectionsTwo from './components/SectionsTwo';
import SectionsThree from './components/SectionsThree';
import SectionsFour from './components/SectionsFour';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionsOne />
        <SectionsTwo />
        <SectionsThree />
        <SectionsFour />
      </main>
      <Footer />
    </div>
  );
}